import './style.css';
import { connect } from 'react-redux';
import { changeTheme } from '../../../actions'
import { useState, useRef, useEffect } from 'react'
const DesktopThemeSwitcher = ({ changeTheme }) => {
    const [themeDropDownActive, setThemeDropDownActive] = useState(false)
    const dropDownItem = useRef()
    useEffect(() => {
        const afzal = () => {
            if (themeDropDownActive){
                setThemeDropDownActive(false)   
            }
        }
        document.body.addEventListener('click', afzal)

        return () => {
            document.body.removeEventListener('click', afzal)
        }
    }, [themeDropDownActive])
    const handleClick = (e) => {
        const themeName = e.target.dataset.theme
        document.body.className = themeName
        changeTheme(themeName)
        ToggleDropDown()
        
    }

    const ToggleDropDown = (e) => {
        // if (){
        //     e.stopPropagation()
        // }
        if (themeDropDownActive){
            dropDownItem.current.style.opacity = "0";
            setTimeout(closeDropDown, 100)

        }
        else{
            setThemeDropDownActive(true)
            setTimeout(showDropDown, 25)
        }
        
        
    }
    const showDropDown = () => {
        dropDownItem.current.style.opacity = "1";
    }
    const closeDropDown = () => {
        setThemeDropDownActive(false)
    }
    return (
        <>
        <li className="nav-item theme-nav" onClick={ToggleDropDown}>
            <div className="nav-link">Theme</div>
            <div className="theme-dropdown" ref={dropDownItem} style={{display: themeDropDownActive ? "block" : "none"}}>
                <div className="theme-list">
                    <div className="default-theme item" onClickCapture={handleClick} data-theme="default">
                        {/* <div className="default-theme-color"></div> */}
                        <span className="default-theme-text text" data-theme="default">Default</span>
                    </div>
                    <div className="blue-theme item" onClickCapture={handleClick} data-theme="blue">
                        {/* <div className="blue-theme-color"></div> */}
                        <span className="blue-theme-text text"  data-theme="blue">Blue</span>
                    </div>
                    <div className="light-theme item" onClickCapture={handleClick} data-theme="light">
                        {/* <div className="light-theme-color"></div> */}
                        <span className="light-theme-text text" data-theme="light">Light</span>
                    </div>
                </div>
            </div>
        </li>
        </>
    )
}

export default connect(null, { changeTheme })(DesktopThemeSwitcher)